module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-09-e7d8f394ce505a07985ad3a3d339b1d8.png";